var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgX20Px = function SvgX20Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9CA3AF",
    d: "M3.333 16.667 16.668 3.333 3.333 16.667Zm0-13.334 13.334 13.334L3.333 3.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.333 3.333 13.334 13.334m-13.334 0L16.668 3.333 3.333 16.667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M0 0h20v20H0z"
  })));
};
export default SvgX20Px;